var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"console-tips"},[(_vm.consoleTipsList && _vm.consoleTipsList[_vm.index])?_c('div',{domProps:{"innerHTML":_vm._s(_vm.consoleTipsList[_vm.index].content)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }